import { useBotVariables } from '../../../store/flow'
import { useGlobalStorages } from './useGlobalStorages'
import { evaluateCriteria } from '../../../lib/rjsf-validation/utils'
import { formatValidators } from '../../../lib/rjsf-validation/validationSchema'

export function useCustomValidationForReadOnlyStorageName() {
  const botVariables = useBotVariables()
  const globalStorages = useGlobalStorages()

  const additionalParams = { botVariables, globalStorages }
  const { criteria, getErrorMessage } = formatValidators['notAReadonlyStorageName']
  return {
    getErrorMessage: (name: string) => getErrorMessage(name, additionalParams),
    isReadOnlyStorageName: (name: string) => !evaluateCriteria(criteria, name, additionalParams)
  }
}
